import { render, staticRenderFns } from "./CreatorCard.vue?vue&type=template&id=35f2eee6&scoped=true&"
import script from "./CreatorCard.vue?vue&type=script&lang=ts&"
export * from "./CreatorCard.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorCard.vue?vue&type=style&index=0&id=35f2eee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2eee6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
